<mat-toolbar class="d-flex justify-content-between">
  <div class="d-flex align-items-center">
    @if (showBack) {
    <button mat-icon-button (click)="onGoBack()" class="mr-2">
      <mat-icon>arrow_back</mat-icon>
    </button>
    }
    <div class="d-flex flex-column">
      <h1 class="p-0 m-0">
        {{ title }}
      </h1>
      @if (breadcrumb.length) {
      <div class="mat-caption text-grey">
        {{ breadcrumb.join(' | ') }}
      </div>
      }
    </div>
  </div>

  <div>
    <ng-content></ng-content>
  </div>
</mat-toolbar>
<mat-divider></mat-divider>
